import React, { Component } from 'react';
import download from '../../assets/download.png';

export default class Others extends Component {
  render() {
    return (
      <section id="lain-lainnya">
        <p style={{fontSize: '18px', color: "#0085C7", fontWeight: '600', marginBottom: '25px'}}>Lain - Lainnya</p>
        <a target="_blank" href="https://drive.google.com/file/d/1HA_nZCPnjvY40Hlo6KRcVXqdBFzzmoU9/view?usp=sharing" style={{color: '#0085C7'}}>
          <table class="table-borderless mb-3" style={{fontSize: '15px', fontWeight: '600', color: '#0085C7'}}>
            <tr>
              <td>
                <img src={download} alt="download" style={{width: '30px', height: '30px', marginRight: '10px'}}/>
              </td>
              <td>
                Undang Undang Nomor 11 Tahun 2008 tentang Informasi dan Transaksi Elektronik
              </td>
            </tr>
          </table>
        </a>
        <a target="_blank" href="https://drive.google.com/file/d/1KMjirXaFdydf3cv4DDMeGZ_lqPVmepCj/view?usp=sharing" style={{color: '#0085C7'}}>
          <table class="table-borderless mb-3" style={{fontSize: '15px', fontWeight: '600', color: '#0085C7'}}>
            <tr>
              <td>
                <img src={download} alt="download" style={{width: '30px', height: '30px', marginRight: '10px'}} />
              </td>
              <td>
                Peraturan Pemerintah No 82 Tahun 2012 tentang Penyelenggaraan Sistem dan Transaksi Elektronik
              </td>
            </tr>
          </table>
        </a>
        <a target="_blank" href="https://drive.google.com/file/d/1MBWPVm5jsvXLFC9M_mpnMjTQ4McKPy25/view?usp=sharing" style={{color: '#0085C7'}}>
          <table class="table-borderless mb-3" style={{fontSize: '15px', fontWeight: '600', color: '#0085C7'}}>
            <tr>
              <td>
                <img src={download} alt="download" style={{width: '30px',height: '30px', marginRight: '10px'}}/>
              </td>
              <td>
                Peraturan Menteri Kominfo No 11 Tahun 2018 tentang Penyelenggaraan Sertifikasi Elektronik
              </td>
            </tr>
          </table>
        </a>
        <a target="_blank" href="https://drive.google.com/file/d/1s0WXgwS3K3FXzv5MV7HCC41x6dt0u4Jo/view?usp=sharing" style={{color: '#0085C7'}}>
          <table class="table-borderless mb-3" style={{fontSize: '15px', fontWeight: '600', color: '#0085C7'}}>
            <tr>
              <td>
                <img src={download} alt="download" style={{width: '30px',height: '30px', marginRight: '10px'}}/>
              </td>
              <td>
                Panduan Penggunaan Sertifikat Elektronik
              </td>
            </tr>
          </table>
        </a>
        <a target="_blank" href="https://drive.google.com/file/d/1A8Zr1d2mc2DbirmXt1iOQCmzPQSbTR5f/view?usp=sharing" style={{color: '#0085C7'}}>
          <table class="table-borderless mb-3" style={{fontSize: '15px', fontWeight: '600', color: '#0085C7'}}>
            <tr>
              <td>
                <img src={download} alt="download" style={{width: '30px',height: '30px', marginRight: '10px'}}/>
              </td>
              <td>
              Panduan Validasi Tanda Tangan Elektronik Tersertifikasi
              </td>
            </tr>
          </table>
        </a>
      </section>
    )
  }
}
